import React from 'react';
import { FormattedMessage } from 'react-intl';

export default props => (
  <div className="logged-in-user-info">
    <div className="pull-right">
      <button type="button" className="btn-link" onClick={props.onLogout}>
        <FormattedMessage
          id="loggedInUser.logout"
          defaultMessage="Log out"
        />
      </button>
    </div>
    <p>
      <span className="text-muted mr-1">
        <FormattedMessage
          id="loggedInUser.loggedInAS"
          defaultMessage="You are logged in as"
        />
      </span>
      <b className="mr-1">{props.user.firstName}</b>
      <span>({props.user.email})</span>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/desktop/components/logged-in-user.js